export const ENQUIRY_SOURCE = {
  UNKNOWN: "UNKNOWN",
  WEB_ORCA: "WEB_ORCA",
  WEB_RETOOL: "WEB_RETOOL",
  WEB_B2C: "WEB_B2C",
  MOBILE_CUSTOMER: "MOBILE_CUSTOMER",
} as const;

export type EnquirySource =
  (typeof ENQUIRY_SOURCE)[keyof typeof ENQUIRY_SOURCE];
